module.exports = __webpack_public_path__ + "img/aws.0589ea93.svg";